<script>
export default {
  computed: {
    isEmailTab() {
      return (
        this.$route.name === 'inbox_view_email_thread' ||
        this.$route.query.tab === 'emails'
      );
    },
  },
};
</script>

<template>
  <div class="acl-vazio-chat">
    <section
      class="acl-empty-conversation-state"
      aria-labelledby="acl-inbox-empty-state-title"
    >
      <div class="acl-empty-conversation-state__illustration">
        <img
          class="m-4 w-32 block dark:hidden"
          src="dashboard/assets/images/no-chat.svg"
          alt=""
          aria-hidden="true"
        />
      </div>
      <h2
        id="acl-inbox-empty-state-title"
        class="acl-empty-conversation-state__title"
      >
        {{
          isEmailTab
            ? $t('INBOX.EMAIL.SELECT_TITLE')
            : $t('INBOX.CENTER.SELECT_TITLE')
        }}
      </h2>
      <p class="acl-empty-conversation-state__description">
        {{
          isEmailTab
            ? $t('INBOX.EMAIL.SELECT_DESCRIPTION')
            : $t('INBOX.CENTER.SELECT_DESCRIPTION')
        }}
      </p>
    </section>
  </div>
</template>
